'use client';

import { useIntl } from 'react-intl';
import type { PropsWithChildren } from 'react';

export type RatingIconsWithInfoButtonProps = PropsWithChildren & {
  customerReviewsSectionId: string;
};

export const InpageLink = ({
  customerReviewsSectionId,
  children,
}: RatingIconsWithInfoButtonProps) => {
  const { formatMessage } = useIntl();

  return (
    <a
      href={`#${customerReviewsSectionId}`}
      onClick={(event) => {
        event.preventDefault();
        event.currentTarget.blur();

        const customerReviewsSection = document.getElementById(customerReviewsSectionId);

        if (customerReviewsSection) {
          customerReviewsSection.setAttribute('tabindex', '-1');
          customerReviewsSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
          customerReviewsSection.focus();
          customerReviewsSection.blur();
        }
      }}
      tabIndex={0}
      aria-label={formatMessage({
        id: 'customerRatings.ratingIconsWithInfo.aria.label',
        defaultMessage: 'zu den Produktbewertungen springen',
      })}
    >
      {children}
    </a>
  );
};
